<template>
  <p class="text-h6 mb-2">{{ $t("component.notFoundModel.brandWrongTitle") }}</p>
  <p v-if="isMultibrand" class="mb-6 text-on-surface-variant">
    {{ $t("component.notFoundModel.brandWrongMultibrandDescription") }}
  </p>
  <template v-else>
    <p class="mb-2 text-on-surface-variant">
      {{ $t("component.notFoundModel.brandWrongOwnBrandDescription", { brand }) }}
    </p>
    <p class="mb-6 text-on-surface-variant">
      {{ $t("component.notFoundModel.brandWrongOwnBrandSupportLine") }}
    </p>
  </template>

  <v-btn
    v-if="isMultibrand"
    block
    color="primary"
    class="mb-3"
    @click="emit('back-to-select-brand')"
  >
    {{ $t("component.notFoundModel.brandWrongBackToSelectBrand") }}
  </v-btn>
  <v-btn block color="primary" variant="outlined" class="mb-3" @click="emit('talk-to-support')">
    {{ $t("component.notFoundModel.brandWrongTalkToSupport") }}
  </v-btn>
  <v-btn block variant="text" @click="emit('cancel')">
    {{ $t("component.notFoundModel.brandWrongCancel") }}
  </v-btn>
</template>

<script setup lang="ts">
  defineProps<{ isMultibrand: boolean; brand: string }>();
  const emit = defineEmits<{ "back-to-select-brand": []; "talk-to-support": []; cancel: [] }>();
</script>
